import styled from 'styled-components';

import Icon from '../../../_shared/components/Icon';

export const StyledDiv = styled.div`
  width: ${props => (props.isOmp ? '450px' : '600px')};
  display: flex;
  max-height: 75vh;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.COLORS.BASE};

  .header {
    padding: ${({ isFetching }) => (isFetching ? '24px' : '24px 24px 0')};
    height: ${({ isFetching }) => (isFetching ? 'max-content' : '')};
    border-radius: 3px;
    width: 100%;
  }

  .header-title {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    font-style: normal;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: normal;
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    padding-bottom: 24px;
  }

  .header-title-promo {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    font-style: normal;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: normal;
    margin-bottom: 24px;
    width: 552px;
    height: 68px;
    border: 2px solid ${({ theme }) => theme.COLORS.BRAND};
    background: linear-gradient(
        0deg,
        rgba(130, 188, 0, 0.1),
        rgba(130, 188, 0, 0.1)
      ),
      ${({ theme }) => theme.COLORS.BASE};
    box-sizing: border-box;
    padding-top: 20px;
    padding-left: 20px;
  }

  .line {
    margin: 24px 0;
  }

  .content-1 {
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    font-style: normal;
    font-size: 24px;
    line-height: 24px;
  }

  .message {
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    font-style: normal;
    font-size: 16px;
    line-height: 16px;
  }

  .content-2 {
    line-height: 1.44;
    letter-spacing: normal;
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    padding-bottom: 24px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.7)
    );
  }

  .footer {
    display: flex;
    height: 84px;
  }

  .btn {
    border: none;
    background: ${({ theme }) => theme.COLORS.BASE};
    margin-bottom: 5px;
    padding-left: 1px;
  }

  .btn-text {
    font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;

export const StyledTransportIcon = styled(Icon).attrs({ icon: 'TR5-Union' })`
  height: 24px;
  width: 35px;
  margin-right: 24.15px;
`;

export const CloseButton = styled.button`
  display: inherit;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding-bottom: 18px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  padding-left: 1px;
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 10px;
  height: 11px;
  padding-bottom: 1px;
`;

export const StyledLoadingIndicator = styled.div`
  display: grid;
  justify-content: center;
  margin-bottom: 15px;
`;
